<template>
  <div class="link-views white-bg">
    <template>
      <Tabs type="card">
        <TabPane label="全部实验" name="Q">
          <div class="list"  v-if="virtualQ.Result.length>0">
            <Row :gutter="16">
              <i-col
                :xs="12"
                :sm="12"
                :md="12"
                :lg="8"
                :xl="6"
                :xxl="4"
                v-for="(item,index) in virtualQ.Result"
                :key="index"
                class="listItem lab"
              >
                <Card>
                  <div class="imgBox imgBox1">
                    <router-link :to="{name:'item',params:{id:item.ExpID}}">
                      <img :src="port+item.ExpPicUrl">
                    </router-link>
                    <a class="star" @click="changeCollect(item)">
                      <div v-if="item.IsCollect">
                        <Icon class="theme" type="ios-star"/>
                      </div>
                      <div v-else>
                        <Icon type="ios-star-outline"/>
                      </div>
                    </a>
                  </div>
                  <div class="cardText">
                    <Tooltip :content="item.ExpName">
                      <div class="text-overflow">{{item.ExpName}}</div>
                    </Tooltip>
                  </div>
                </Card>
              </i-col>
            </Row>
 <div class="page-div">
              <Page
                show-total
                :total="virtualQ.records"
                :current="pageDataQ"
                :page-size="size"
                @on-change="changeQ"
              />
            </div>
          </div>
           <div v-else class="nodata">暂无数据</div>
        </TabPane>
        <TabPane label="最近使用" name="Z">
          <div class="list" v-if="virtualZ.Result.length>0">
            <Row :gutter="16">
              <i-col
                :xs="12"
                :sm="12"
                :md="12"
                :lg="8"
                :xl="6"
                :xxl="4"
                v-for="(item,index) in virtualZ.Result"
                :key="index"
                class="listItem lab"
              >
                <Card>
                  <div class="imgBox imgBox1">
                    <router-link :to="{name:'item',params:{id:item.ExpID}}">
                      <img :src="port+item.ExpPicUrl">
                    </router-link>
                  </div>
                  <div class="cardText">
                    <Tooltip :content="item.ExpName">
                      <div class="text-overflow">{{item.ExpName}}</div>
                    </Tooltip>

                    <!-- <span>查看详情</span> -->
                  </div>
                </Card>
              </i-col>
            </Row>
            <div class="page-div">
              <Page
                show-total
                :total="virtualZ.records"
                :current="pageDataZ"
                :page-size="size"
                @on-change="changeZ"
              />
            </div>
          </div>
          <div v-else class="nodata">暂无数据</div>
        </TabPane>
        <TabPane label="我的收藏" name="S">
          <div class="list" v-if="virtualS.Result.length>0">
            <Row :gutter="16" >
              <i-col
                :xs="12"
                :sm="12"
                :md="12"
                :lg="8"
                :xl="6"
                :xxl="4"
                v-for="(item,index) in virtualS.Result"
                :key="index"
                class="listItem lab"
              >
                <Card>
                  <div class="imgBox imgBox1">
                    <router-link :to="{name:'item',params:{id:item.ExpID}}">
                      <img :src="port+item.ExpPicUrl">
                    </router-link>
                    <a class="star">
                      <div>
                        <Icon class="theme" type="ios-star"/>
                      </div>
                    </a>
                  </div>
                  <div class="cardText">
                    <Tooltip :content="item.ExpName">
                      <div class="text-overflow">{{item.ExpName}}</div>
                    </Tooltip>
                  </div>
                </Card>
              </i-col>
            </Row>
 <div class="page-div">
              <Page
                show-total
                :total="virtualS.records"
                :current="pageDataS"
                :page-size="size"
                @on-change="changeS"
              />
            </div>
          </div>
          <div v-else class="nodata">暂无数据</div>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>


<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/student-api.js";
export default {
  name: "virtualLab",
  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      virtualQ: {
        Result: []
      },
      virtualZ: {
        Result: []
      },
      virtualS: {
        Result: []
      },
      pageDataQ: 1,
      pageDataZ: 1,
      pageDataS: 1,
      size: 12
    };
  },
  mounted() {
    this.getpageArr("virtualQ", "Q", 1);
    this.getpageArr("virtualZ", "Z", 1);
    this.getpageArr("virtualS", "S", 1);
  },
  methods: {
    async getpageArr(obj, ExpType, page) {
      this[obj] = await homeApi.GetExperimentList({
        ExpType: ExpType,
        page: page ? page : 1,
        size: this.size ? this.size : 12
      });
      this.loading = false;
    },
    changeCollect(item) {
      homeApi.GetCollect({ ExpID: item.ExpID }).then(res => {
        if (res.success) {
          this.getpageArr("virtualQ", "Q", 1);
          this.getpageArr("virtualZ", "Z", 1);
          this.getpageArr("virtualS", "S", 1);
          this.$Message.success({
            content: res.msg,
            duration: 3
          });
        } else {
          this.$Message.error({
            content: res.msg,
            duration: 3
          });
        }
      });
    },
     changeQ(page){
      this.pageDataQ=page;
     this.getpageArr("virtualQ", "Q", page);
    },
     changeZ(page){
      this.pageDataZ=page;
     this.getpageArr("virtualZ", "Z", page);
    },
    changeS(page){
      this.pageDataS=page;
     this.getpageArr("virtualS", "S", page);
    }
  }
};
</script>

<style scoped>
</style>